import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HighlightCard from './HighlightCard';

export default function FeaturedHighlights() {
  const [highlights, setHighlights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const brandColor = '#e46809';

  useEffect(() => {
    const fetchFeaturedCampaigns = async () => {
      const apiUrl = process.env.REACT_APP_API_URL;
      if (!apiUrl) {
        setError("API URL is not configured.");
        setLoading(false);
        return;
      }

      try {
        // Fetch featured campaigns (assuming you have a featured campaigns endpoint)
        const response = await fetch(`${apiUrl}/campaigns/featured`);
        
        // Check if response is HTML (error page)
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.indexOf('text/html') !== -1) {
          throw new Error('Server returned HTML instead of JSON. Check API endpoint.');
        }
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        setHighlights(data);
      } catch (e) {
        console.error("Failed to fetch highlights:", e);
        setError("Could not load featured campaigns. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedCampaigns();
  }, []);

  const renderContent = () => {
    if (loading) {
      return <p className="text-xl text-gray-500">Loading highlights...</p>;
    }
    if (error) {
      return <p className="text-xl text-red-500">{error}</p>;
    }
    if (highlights.length === 0) {
      return (
        <p className="text-xl text-gray-500 dark:text-gray-400">
          No featured campaigns are available right now.
        </p>
      );
    }
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {highlights.map((highlight) => (
          <HighlightCard key={highlight.id} highlight={highlight} />
        ))}
      </div>
    );
  };

  return (
    <section className="bg-gray-50 dark:bg-gray-900 py-20">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-black uppercase text-gray-800 dark:text-white tracking-widest">
          Featured Highlights
        </h2>
        <div className="w-24 h-1 mx-auto mt-4 mb-12" style={{ backgroundColor: brandColor }} />

        <div className="min-h-[250px] flex items-center justify-center">
            {renderContent()}
        </div>
        
        {highlights.length > 0 && (
            <div className="text-center mt-12">
                <Link 
                    to="/campaigns"
                    className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300"
                >
                    View All Campaigns
                </Link>
            </div>
        )}
      </div>
    </section>
  );
}